import { ActionPayload, ActionType } from '@/types/widget/index'

export const getActionPayload = <T extends ActionPayload = ActionPayload>(type: ActionType, payload?: T) => {
    return {
        type,
        payload
    }
}
